/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Form } from '../models/Form';
import type { FormWaiverUrl } from '../models/FormWaiverUrl';
import type { OpenApiInteger } from '../models/OpenApiInteger';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FormsService {

    /**
     * @param id
     * @returns Form Registration form
     * @throws ApiError
     */
    public static showForm(
        id: OpenApiInteger,
    ): CancelablePromise<Form> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/registration-forms/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param id
     * @param waiverId
     * @returns FormWaiverUrl Waiver download url
     * @throws ApiError
     */
    public static getWaiverDownloadUrl(
        id: OpenApiInteger,
        waiverId: OpenApiInteger,
    ): CancelablePromise<FormWaiverUrl> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/registration-forms/{id}/waivers/{waiverId}/download-url',
            path: {
                'id': id,
                'waiverId': waiverId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

}
